import { dialogTitleClasses } from "@mui/material"
import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ spacing }) => ({
  paper: {
    width: "40%"
  },
  content: {
    [`.${dialogTitleClasses.root}+&`]: {
      paddingTop: spacing(4)
    }
  }
}))
